(() => {
  const S = '[data-htg-compact-configurator]';

  const money = (c, cur) => {
    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || 'en-AU',
        {
          style: 'currency',
          currency: cur || 'AUD',
          minimumFractionDigits: 2
        }
      ).format((Number(c) || 0) / 100);
    } catch (e) {
      return `$${((Number(c) || 0) / 100).toFixed(2)}`;
    }
  };

  class C {
    constructor(r) {
      this.r = r;
      this.mainId = Number(r.dataset.mainVariantId);
      this.mainSellingPlanId = Number(r.dataset.mainSellingPlanId) || null;
      this.mainPrice = Number(r.dataset.mainPrice) || 0;
      this.cur = r.dataset.currencyCode || 'AUD';
      this.discount = Number(r.dataset.attachmentDiscount) || 0;
      this.isPreorder = r.dataset.isPreorder === 'true';

      this.root = (r.dataset.rootUrl || '/').replace(/\/+$/, '');
      this.addUrl = `${this.root}/cart/add.js`.replace(/^\/\//, '/');
      this.cartUrl = `${this.root}/cart`.replace(/^\/\//, '/');

      this.q = r.querySelector('[data-quantity-input]');
      this.btn = r.querySelector('[data-add-complete-system]');
      this.label = r.querySelector('[data-button-label]');
      this.spin = r.querySelector('[data-button-spinner]');
      this.status = r.querySelector('[data-configurator-status]');

      if (this.label) {
        this.label.dataset.original = this.label.textContent.trim();
      }

      this.bind();
      this.total();
    }

    bind() {
      this.r.addEventListener('change', e => {
        if (e.target.matches('[data-component-input]')) {
          this.clear(e.target.dataset.componentType);
          this.total();
        }
      });

      this.r
        .querySelector('[data-quantity-minus]')
        ?.addEventListener('click', () => this.setQ(this.qty - 1));

      this.r
        .querySelector('[data-quantity-plus]')
        ?.addEventListener('click', () => this.setQ(this.qty + 1));

      this.q?.addEventListener('change', () => this.setQ(this.qty));

      this.btn?.addEventListener('click', () => this.add());
    }

    get qty() {
      return Math.max(
        1,
        parseInt(this.q?.value || '1', 10) || 1
      );
    }

    setQ(v) {
      if (this.q) {
        this.q.value = Math.max(1, Number(v) || 1);
      }

      this.total();
    }

    sel(t) {
      return this.r.querySelector(
        `[data-component-input][data-component-type="${t}"]:checked`
      );
    }

    has(t) {
      return !!this.r.querySelector(
        `[data-component-group="${t}"]`
      );
    }

    eff(a) {
      if (!a || a.dataset.isAdapter === 'true') {
        return 0;
      }

      return Math.max(
        0,
        Number(a.dataset.componentPrice || 0) - this.discount
      );
    }

    total() {
      const a = this.sel('attachment');
      const t = (this.mainPrice + this.eff(a)) * this.qty;
      const el = this.r.querySelector('[data-package-total]');

      if (el) {
        el.textContent = money(t, this.cur);
      }
    }

    valid() {
      let ok = true;

      ['clamp', 'attachment'].forEach(t => {
        if (this.has(t) && !this.sel(t)) {
          const e = this.r.querySelector(
            `[data-group-error="${t}"]`
          );

          if (e) {
            e.hidden = false;
          }

          ok = false;
        }
      });

      if (!ok) {
        this.msg(
          'Please complete the required selections.',
          true
        );
      }

      return ok;
    }

    clear(t) {
      const e = this.r.querySelector(
        `[data-group-error="${t}"]`
      );

      if (e) {
        e.hidden = true;
      }

      this.msg('');
    }

    buildItem(id, quantity, properties, sellingPlanId = null) {
      const item = {
        id,
        quantity,
        properties
      };

      if (sellingPlanId) {
        item.selling_plan = sellingPlanId;
      }

      return item;
    }

    async add() {
      if (!this.mainId) {
        this.msg(
          'The main product is not available. Please refresh the page or contact us.',
          true
        );

        return;
      }

      if (!this.valid()) {
        return;
      }

      const clamp = this.sel('clamp');
      const att = this.sel('attachment');
      const q = this.qty;
      const id = `htg-${Date.now()}`;

      const common = {
        '_HTG package':
          this.r.dataset.mainProductTitle || 'Configured system',
        '_HTG package ID': id
      };

      const items = [
        this.buildItem(
          this.mainId,
          q,
          {
            ...common,
            'Configured product': 'Main system'
          },
          this.mainSellingPlanId
        )
      ];

      if (clamp) {
        const clampSellingPlanId =
          Number(clamp.dataset.sellingPlanId) || null;

        items.push(
          this.buildItem(
            Number(clamp.value),
            q,
            {
              ...common,
              'Configured product': 'FHR mounting clamp'
            },
            clampSellingPlanId
          )
        );
      }

      if (att) {
        const attachmentSellingPlanId =
          Number(att.dataset.sellingPlanId) || null;

        items.push(
          this.buildItem(
            Number(att.value),
            q,
            {
              ...common,
              'Configured product': 'Shooting attachment'
            },
            attachmentSellingPlanId
          )
        );
      }

      this.loading(true);
      this.msg('');

      try {
        const res = await fetch(this.addUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items })
        });

        const data = await res.json();

        if (!res.ok) {
          throw new Error(
            data.description ||
            data.message ||
            'The system could not be added to cart.'
          );
        }

        window.location.href = this.cartUrl;
      } catch (e) {
        console.error('[HTG Compact Configurator]', e);

        this.msg(
          e.message ||
          'Something went wrong. Please try again.',
          true
        );
      } finally {
        this.loading(false);
      }
    }

    loading(on) {
      if (!this.btn) {
        return;
      }

      this.btn.disabled = on;

      if (this.spin) {
        this.spin.hidden = !on;
      }

      if (this.label) {
        this.label.textContent = on
          ? this.isPreorder
            ? 'Adding pre-order…'
            : 'Adding system…'
          : (
              this.label.dataset.original ||
              (
                this.isPreorder
                  ? 'Pre-order complete system'
                  : 'Add complete system'
              )
            );
      }
    }

    msg(m, err = false) {
      if (!this.status) {
        return;
      }

      this.status.textContent = m;
      this.status.hidden = !m;
      this.status.classList.toggle('is-error', err);
    }
  }

  function init(s = document) {
    s.querySelectorAll(S).forEach(r => {
      if (r.dataset.htgCompactInitialised === 'true') {
        return;
      }

      r.dataset.htgCompactInitialised = 'true';
      new C(r);
    });
  }

  document.addEventListener('DOMContentLoaded', () => init());

  document.addEventListener(
    'shopify:section:load',
    e => init(e.target)
  );
})();